module.exports = __webpack_public_path__ + "static/media/google-login.9ad67e08.svg";